import React from 'react';
import { Bell, X } from 'lucide-react';

const AnnouncementsSection = ({
  announcements,
  setShowAnnouncementModal,
  handleDeleteAnnouncement
}) => {
  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="text-2xl lg:text-3xl font-bold text-gray-900">Announcements</h1>
          <p className="text-gray-500">Send notifications to all or selected mentees</p>
        </div>
        <button 
          onClick={() => setShowAnnouncementModal(true)}
          className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-lg flex items-center gap-2"
          data-testid="create-announcement-btn"
        >
          <Bell className="w-5 h-5" />
          New Announcement
        </button>
      </div>
      
      {/* Announcement List */}
      <div className="bg-white rounded-xl border">
        <div className="p-4 border-b">
          <h2 className="font-semibold">Active Announcements</h2>
        </div>
        <div className="divide-y">
          {announcements.length === 0 ? (
            <div className="p-8 text-center text-gray-500">
              No announcements yet. Click "New Announcement" to create one.
            </div>
          ) : (
            announcements.map((announcement) => (
              <div key={announcement.id} className="p-4">
                <div className="flex items-start justify-between mb-2">
                  <div>
                    <h3 className="font-semibold text-gray-900">{announcement.title}</h3>
                    <p className="text-sm text-gray-600">{announcement.message}</p>
                  </div>
                  <button
                    onClick={() => handleDeleteAnnouncement(announcement.id)}
                    className="p-2 text-red-500 hover:bg-red-50 rounded-lg"
                    title="Delete"
                  >
                    <X className="w-4 h-4" />
                  </button>
                </div>
                <div className="flex items-center gap-4 text-xs text-gray-500">
                  <span className={`px-2 py-1 rounded-full ${announcement.target_type === 'all' ? 'bg-blue-100 text-blue-700' : 'bg-yellow-100 text-yellow-700'}`}>
                    {announcement.target_type === 'all' ? 'All Mentees' : 'Selected Users'}
                  </span>
                  <span>Created: {new Date(announcement.created_at).toLocaleDateString()}</span>
                  {announcement.expires_at && (
                    <span>Expires: {new Date(announcement.expires_at).toLocaleDateString()}</span>
                  )}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default AnnouncementsSection;
